import ColorSelect from './component'

export default ColorSelect